/**
 * ESM view of the calendar builders.
 *
 * The implementation lives in event-calendar.cjs so the CommonJS backend and
 * the bundled frontends share exactly one copy.
 */
import calendar from './event-calendar.cjs';

export const toCalendarStamp = calendar.toCalendarStamp;
export const allDayStamps = calendar.allDayStamps;
export const buildIcs = calendar.buildIcs;
export const googleCalendarUrl = calendar.googleCalendarUrl;
export const calendarLocation = calendar.calendarLocation;
export default calendar;
